<router-outlet></router-outlet>
<ngx-ui-loader
  [fgsColor]="'#000'"
  [fgsTemplate]="foregroundSpinner"></ngx-ui-loader>

<ng-template #foregroundSpinner>
  <img [src]="assetsConst.Logo" />
</ng-template>
